import { Avatar, Button, IconButton } from "@/components/ui";
import { useAppSelector } from "@/config/store";
import { IEdoCourseComment } from "@/shared/model/edo-course-comment.model";
import { IEdoWallComment } from "@/shared/model/edo-wall-comment.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { Send } from "lucide-react";
import { useState } from "react";

type CreateCommentProps = {
  reloadCommentList: () => void;
  saveComment: (comment: IEdoWallComment) => Promise<IEdoWallComment>;
  defaultValueComment: IEdoWallComment;
} | {
  reloadCommentList: () => void;
  saveComment: (comment: IEdoCourseComment) => Promise<IEdoCourseComment>;
  defaultValueComment: IEdoCourseComment;
}

const CreateComment = (props: CreateCommentProps) => {
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );
  const [comment, setComment] = useState<IEdoWallComment | IEdoCourseComment>({ ...props.defaultValueComment });
  const [updating, setUpdating] = useState<boolean>(false);

  const { reloadCommentList, saveComment } = props;

  const clearComment = () => {
    setComment({ ...props.defaultValueComment, description: "" });
  };

  const handleSaveComment = async () => {
    setUpdating(true);
    await saveComment(comment);
    setUpdating(false);
    clearComment();
    reloadCommentList();
  };

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="hidden shrink-0 md:block">
        <Avatar
          className="h-10 w-10"
          fallback={`${account.firstName?.[0] ?? ""}${account.lastName?.[0] ?? ""}`}
        />
      </div>
      <div className="min-w-0 flex-1">
        <textarea
          className="flex min-h-[60px] w-full rounded-2xl border-2 border-[var(--color-mockup-border)] bg-surface px-4 py-3 text-sm font-editorial text-[var(--color-mockup-text)] placeholder:text-[var(--color-mockup-text-light)] focus:outline-none focus:border-primary focus:shadow-[0_4px_12px_rgba(18,181,170,0.15)] transition-all duration-200 resize-none"
          placeholder="Aggiungi un commento al post"
          value={comment.description ?? ""}
          onChange={(e) =>
            setComment({ ...comment, description: e.target.value })
          }
          rows={2}
        />
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <IconButton
          className="md:hidden"
          disabled={!comment.description || updating}
          onClick={handleSaveComment}
          aria-label="Invia"
        >
          <Send className="h-5 w-5" />
        </IconButton>
        <Button
          className="hidden md:inline-flex"
          disabled={!comment.description || updating}
          onClick={handleSaveComment}
        >
          {updating ? "..." : "Invia"}
        </Button>
      </div>
    </div>
  );
};

export default CreateComment;